import React, { useEffect, useState } from "react";
import "./css.css";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import axios from 'axios';
import { db } from "../config_firebase";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import { Form as Form1 } from "react-bootstrap";
import {
  collection,
  addDoc,
  getDocs,
  doc,
} from "firebase/firestore";

/**
 * @author
 * @function Login
 *
 **/

export const Login = (props) => {
  const history = useNavigate();

  useEffect(() => {
    localStorage.clear();
    const random_group = (Math.floor(Math.random() * 4) + 1);
    localStorage.setItem("random_group", random_group);
    console.log(random_group);
  }, []);

  async function addclick(data) {
    const docRef = await addDoc(collection(db, "clicksdata"), {
      data,
    });
  }

  return (
    <div className="main">
      <div className="login">
        <Formik
          initialValues={{ user_id: "" }}
          onSubmit={(values) => {
            console.log(values.user_id);
            localStorage.setItem("user_id", values.user_id);
            const login_button = {
              time: Date.now(),
              userId: values.user_id,
              buttonType: "login_button",
            };
            addclick(login_button);
            console.log("g", values.user_id);
            history(`/consent/?,${values.user_id}`);
          }}
          validationSchema={Yup.object({
            user_id: Yup.string()
              .required("id is required"),
          })}
        >
          {(formik, isSubmitting) => (
            <Form>
              <div className="loginform">
                <div className="text-center">
                  <label htmlFor="user_id">
                    Please enter your Connect ID
                  </label>
                </div>
                <Field
                  name="user_id"
                  className={
                    formik.touched.user_id && formik.errors.user_id
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  type="text"
                />
                <Form1.Text className="text-muted">
                  We'll never share your information with anyone else.
                </Form1.Text>
              </div>

              <div className="text-center">
                <Button variant="outline-light" className="loginbutton" type="submit">
                  Submit
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
